import { render, staticRenderFns } from "./add-friend.vue?vue&type=template&id=7ea7556c"
import script from "./add-friend.vue?vue&type=script&lang=js"
export * from "./add-friend.vue?vue&type=script&lang=js"
import style0 from "./add-friend.vue?vue&type=style&index=0&id=7ea7556c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports